import { render, staticRenderFns } from "./PayoutsDelete.vue?vue&type=template&id=2583570a&scoped=true"
import script from "./PayoutsDelete.vue?vue&type=script&lang=js"
export * from "./PayoutsDelete.vue?vue&type=script&lang=js"
import style0 from "./PayoutsDelete.vue?vue&type=style&index=0&id=2583570a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2583570a",
  null
  
)

export default component.exports